import { MovementDataRenderer } from '@features/gateCommon';
import { GateMessagesSubscription } from '@features/gateCommon/components/GateMessagesSubscription';
import { type FC } from 'react';

interface Props {
  movementId: number | null;
}

/**
 * Acota la suscripción de mensajes de compuerta a la que este modal tiene abierta
 * (AMARU-862/US-006). El montaje global (`GlobalComponents`) sigue sin `gateId` — sigue
 * cubriendo el refresco de tableros que muestran varias compuertas a la vez — así que esto es
 * ADITIVO, no un reemplazo: acota el tráfico de este consumidor puntual sin tocar el
 * comportamiento de los demás.
 */
export const GateOperationSubscription: FC<Props> = ({ movementId }) => {
  if (movementId == null) return null;

  return (
    <MovementDataRenderer
      movementId={movementId}
      render={({ gate }) => <GateMessagesSubscription gateId={gate.id} />}
      fallback={() => null}
    />
  );
};
